var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpiritualityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3433_3666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 2.75C14.1667 2.02065 13.8682 1.32118 13.3368 0.805456C12.8054 0.289731 12.0848 0 11.3333 0C10.5819 0 9.86122 0.289731 9.32986 0.805456C8.79851 1.32118 8.5 2.02065 8.5 2.75C8.5 3.47935 8.79851 4.17882 9.32986 4.69454C9.86122 5.21027 10.5819 5.5 11.3333 5.5C12.0848 5.5 12.8054 5.21027 13.3368 4.69454C13.8682 4.17882 14.1667 3.47935 14.1667 2.75ZM8.88516 11.3438L9.89896 12.6973C10.1867 13.0797 10.6206 13.3289 11.1031 13.3891C11.5857 13.4492 12.0727 13.316 12.449 13.0152L16.3448 9.92148C17.1018 9.31992 17.2125 8.23711 16.5927 7.50234C15.9729 6.76758 14.8573 6.66016 14.1003 7.26172L11.6565 9.20391L10.4966 7.65703C9.81042 6.7332 8.70365 6.1875 7.52604 6.1875C6.15807 6.1875 4.90521 6.92227 4.26771 8.09531L2.11615 12.0699C1.22187 13.7242 1.7 15.7609 3.24948 16.8738L5.60469 18.5625H1.77083C0.792448 18.5625 0 19.3316 0 20.2812C0 21.2309 0.792448 22 1.77083 22H10.9792C11.7451 22 12.4224 21.523 12.6615 20.8184C12.9005 20.1137 12.6482 19.3402 12.0328 18.8977L6.89297 15.2109L8.88516 11.3438Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3433_3666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiritualityIcon);
export default __webpack_public_path__ + "static/media/SpiritualityIcon.24ae7895ddff5ee383c2e698f1f1b259.svg";
export { ForwardRef as ReactComponent };